import { ApolloClient, InMemoryCache, TypePolicies } from "@apollo/client";
import { createNetworkStatusNotifier } from "react-apollo-network-status";
import { AUTH_TYPE } from "aws-appsync-auth-link";

import createApolloLink from "./createApolloLink";

const { link: networkStatusLink, useApolloNetworkStatus } =
  createNetworkStatusNotifier();

function createApolloClient(authType: AUTH_TYPE, typePolicies?: TypePolicies) {
  const client = new ApolloClient({
    cache: new InMemoryCache({ typePolicies }),
    link: networkStatusLink.concat(createApolloLink(authType)),
  });
  return { client, useApolloNetworkStatus };
}

export default createApolloClient;
export { AUTH_TYPE };
